import { useTranslation } from 'react-i18next';

import { DataPanel, DataPanelInlineItem, DebugView } from '@/ui';
import type { AppInfo, DeviceInfo } from '@/signalr';
import { AppInfoPanel } from './AppInfoPanel';
import { DeviceInfoDebugPanel } from './DeviceInfoDebugPanel';

export type DebugInfoPanelProps = {
  incidentId: string;
  appInfo: AppInfo;
  deviceInfo: DeviceInfo;
};

export function DebugInfoPanel({ incidentId, appInfo, deviceInfo }: DebugInfoPanelProps) {
  const { t } = useTranslation();

  return (
    <DebugView>
      <DataPanel header="Incident Info">
        <DataPanelInlineItem title={t('Label_Id')} value={incidentId} allowCopyToClipboard />
      </DataPanel>

      <AppInfoPanel appInfo={appInfo} />

      <DeviceInfoDebugPanel deviceInfo={deviceInfo} />
    </DebugView>
  );
}
